import {h, Fragment} from "preact"
// export default function Checkbox({ value, selected, onChange, className = "" }) {
//     return (
//         <label className={`flex items-center cursor-pointer ${className}`}>
//             <input
//                 type="checkbox"
//                 checked={selected}
//                 onChange={onChange}
//                 className="hidden peer"
//             />
//             <span className="text-13-120 text-black-55 peer-checked:text-13-120-600 peer-checked:text-black">
//                 {value}
//             </span>
//         </label>
//     )
// }
export default function Checkbox({ value, selected, onChange, className = "" }) {
    // create a stable id for the input so the label ties to it
    const id = `cb-${String(value).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  
    return (
      <label htmlFor={id} className={`flex items-center cursor-pointer ${className}`}>
        <input
          id={id}
          type="checkbox"
          checked={selected}
          onChange={onChange}
          className="hidden peer"
        />
        {/* indicator: only visible when checked */}
        <span className="check-indicator h-6 mr-6 bg-black hidden peer-checked:block" aria-hidden="true" />
        <span className="text-13-120 text-black-55 peer-checked:text-13-120-600 peer-checked:text-black">
          {value}
        </span>
      </label>
    ); 
  }
  
